import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';

import { AiCompanionChip } from './AiCompanionChip';
import { SavedSearchesChip } from './SavedSearchesChip';
import { ShortlistChip } from './ShortlistChip';

import barStyles from '../FilterBarV2.module.scss';

export const FilterBarStart: FC = () => (
	<div className={cx(barStyles.hiddenWhenSticky, barStyles.actionChips)} data-testid="filter-bar-rail-actions">
		<AiCompanionChip />
		<SavedSearchesChip />
		<ShortlistChip />
		<span className={barStyles.separator} />
	</div>
);
